var _rect, _mask, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFuelProduct(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 6,
    fill: "#FFF5F7"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_1526_2140",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.101 8L13.351 19.25L12.7799 20.4636C10.2545 25.83 14.17 32 20.101 32C26.032 32 29.9475 25.83 27.4221 20.4636L26.851 19.25L20.101 8Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0558 28.7483C20.823 28.818 21.9832 28.6955 23.0084 28.0902C24.0606 27.4689 24.9342 26.3579 25.099 24.5456L24.1031 24.455C23.9678 25.9427 23.279 26.7692 22.4999 27.2291C21.6939 27.7051 20.7541 27.8076 20.1463 27.7524L20.0558 28.7483ZM13.351 19.25L12.4935 18.7355L12.4676 18.7787L12.4462 18.8242L13.351 19.25ZM20.101 8L20.9585 7.4855L20.101 6.05635L19.2435 7.4855L20.101 8ZM12.7799 20.4636L13.6847 20.8894L13.6847 20.8894L12.7799 20.4636ZM27.4221 20.4636L26.5172 20.8894L27.4221 20.4636ZM26.851 19.25L27.7558 18.8242L27.7344 18.7787L27.7085 18.7355L26.851 19.25ZM14.2085 19.7645L20.9585 8.5145L19.2435 7.4855L12.4935 18.7355L14.2085 19.7645ZM13.6847 20.8894L14.2558 19.6758L12.4462 18.8242L11.8751 20.0378L13.6847 20.8894ZM20.101 31C14.903 31 11.4714 25.5926 13.6847 20.8894L11.8751 20.0378C9.03756 26.0675 13.437 33 20.101 33V31ZM26.5172 20.8894C28.7305 25.5926 25.2989 31 20.101 31V33C26.765 33 31.1644 26.0675 28.3269 20.0378L26.5172 20.8894ZM25.9462 19.6758L26.5172 20.8894L28.3269 20.0378L27.7558 18.8242L25.9462 19.6758ZM19.2435 8.5145L25.9935 19.7645L27.7085 18.7355L20.9585 7.4855L19.2435 8.5145Z",
    fill: "#D91F05",
    mask: "url(#path-2-inside-1_1526_2140)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFuelProduct);
export default __webpack_public_path__ + "static/media/fuelProduct.26ca71868d8297fcd7d16d9f592d2916.svg";
export { ForwardRef as ReactComponent };